const memberList = [
  // 윗 줄
  {
    memberImg: '/images/member/하예영.png',
    name: '하예영',
    major: 'Data Science 23',
    position: null,
    github: 'https://github.com/hayeyoung',
  },
  {
    memberImg: '/images/member/주아정.png',
    name: '주아정',
    major: 'Computer Science 23',
    position: null,
    github: 'https://github.com/ajung7038',
  },
  {
    memberImg: '/images/member/이해림.png',
    name: '이해림',
    major: 'Computer Science 23',
    position: null,
    github: 'https://github.com/lhaerim',
  },
  {
    memberImg: '/images/member/황수연.png',
    name: '황수연',
    major: 'Computer Science 20',
    position: null,
    github: 'https://github.com/syhwang1231',
  },
  {
    memberImg: '/images/member/신진영.png',
    name: '신진영',
    major: 'Computer Science 20',
    position: '부회장',
    github: 'https://github.com/Jjinyshin',
  },
  {
    memberImg: '/images/member/정민주.png',
    name: '정민주',
    major: 'Computer Science 22 ',
    position: null,
    github: 'https://github.com/quothraven1122',
  },

  {
    memberImg: '/images/member/하고은.png',
    name: '하고은',
    major: 'Computer Science 21',
    position: null,
    github: 'https://github.com/hagoeun0119',
  },
  {
    memberImg: '/images/member/윤서희.png',
    name: '윤서희',
    major: 'Software Convergence 21',
    position: null,
    github: 'https://github.com/seohee0925',
  },
  {
    memberImg: '/images/member/이지은.png',
    name: '이지은',
    major: 'Computer Science 22',
    position: null,
    github: 'https://github.com/ljinny',
  },
  {
    memberImg: '/images/member/경민서.png',
    name: '경민서',
    major: 'Software Convergence 22',
    position: null,
    github: 'https://github.com/mxinseo',
  },

  {
    memberImg: '/images/member/최민선.png',
    name: '최민선',
    major: 'Software Convergence 21',
    position: null,
    github: 'https://github.com/choiminsun24',
  },
  {
    memberImg: '/images/member/서정연.png',
    name: '서정연',
    major: 'Software Convergence 21',
    position: '프론트엔드장',
    github: 'https://github.com/cyndii20',
  },
  // 아래 줄
  {
    memberImg: '/images/member/김진영.png',
    name: '김진영',
    major: 'Software Convergence 21',
    position: null,
    github: 'https://github.com/coringcoring',
  },
  {
    memberImg: '/images/member/장나리.png',
    name: '장나리',
    major: 'Computer Science 21',
    position: null,
    github: 'https://github.com/skfl0282',
  },
  {
    memberImg: '/images/member/김다연.png',
    name: '김다연',
    major: 'Software Convergence 21',
    position: null,
    github: 'https://github.com/Haileyyyyyyyy',
  },
  {
    memberImg: '/images/member/윤현서.png',
    name: '윤현서',
    major: 'Data Science 23',
    position: null,
    github: 'https://github.com/gustj3104',
  },
  {
    memberImg: '/images/member/최서윤.png',
    name: '최서윤',
    major: 'Data Science 23',
    position: null,
    github: 'https://github.com/choiseoyoon0330',
  },
  {
    memberImg: '/images/member/문채일.png',
    name: '문채일',
    major: 'Computer Science 22',
    position: null,
    github: 'https://github.com/chae2',
  },
  {
    memberImg: '/images/member/정서연.png',
    name: '정서연',
    major: 'Computer Science 22',
    position: null,
    github: 'https://github.com/seoy-54',
  },
  {
    memberImg: '/images/member/오지수.png',
    name: '오지수',
    major: 'Computer Science 21',
    position: '백엔드장',
    github: 'https://github.com/5jisoo',
  },
  {
    memberImg: '/images/member/김수현.png',
    name: '김수현',
    major: 'Computer Science 22',
    position: null,
    github: 'https://github.com/suuxxirr',
  },
  {
    memberImg: '/images/member/정지원.png',
    name: '정지원',
    major: 'Software Convergence 22',
    position: null,
    github: 'https://github.com/codeJiwon',
  },
  {
    memberImg: '/images/member/김혜림.png',
    name: '김혜림',
    major: 'Data Science 23',
    position: null,
    github: 'https://github.com/kimhyerims',
  },
  {
    memberImg: '/images/member/류미성.png',
    name: '류미성',
    major: 'Computer Science 21',
    position: null,
    github: 'https://github.com/misung-dev',
  },
  {
    memberImg: '/images/member/조영서.png',
    name: '조영서',
    major: 'Computer Science 21',
    position: '회장',
    github: 'https://github.com/dudrhy12',
  },
  {
    memberImg: '/images/member/이채은.png',
    name: '이채은',
    major: 'Computer Science 22',
    position: null,
    github: 'https://github.com/chennielee',
  },
];

export default memberList;
